import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Divider, Form, Modal, Spin, message } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { addSVG, deleteSVG, editSVG } from "../../assets/settings/SVGs";
import ModalAddNewTax from "../../components/settings/modal/ModalAddNewTax";
import ModalEditTax from "../../components/settings/modal/ModalEditTax";
import { deleteTax, getLocations, getTaxes } from "../../network/settings";
import queryClient from "../../services/react-query/queryClient";

type Props = {};

const Taxes = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [Tax, setTax] = useState();
  const navigate = useNavigate();
  const { locale } = useIntl();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showEditModal = (body: any) => {
    setTax(body);
    setIsEditModalOpen(true);
  };

  const handleEditCancel = () => {
    setIsEditModalOpen(false);
  };
  const [form] = Form.useForm();

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const { data: locations, isLoading } = useQuery(["location"], () =>
    getLocations()
  );
  const { data: taxes, isLoading: isLoadingTaxes } = useQuery(["Taxes"], () =>
    getTaxes({}, true)
  );
  const options = [
    {
      value: "1",
      label: "5",
    },
    {
      value: "2",
      label: "10",
    },
    {
      value: "3",
      label: "15",
    },
  ];

  const { mutate: DeleteTax } = useMutation(deleteTax, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404
      ) {
        message.error(res?.response?.data?.message);
      } else {
        message.success("Tax Deleted");
        queryClient.invalidateQueries(["Taxes"]);
      }
    },
  });
  const intl = useIntl();
  console.log(taxes);

  return (
    <>
      <Modal
        width={"50%"}
        destroyOnClose
        open={isModalOpen}
        onCancel={handleCancel}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
      >
        <ModalAddNewTax close={handleCancel} />
      </Modal>
      <Modal
        width={"50%"}
        destroyOnClose
        open={isEditModalOpen}
        onCancel={handleEditCancel}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
      >
        <ModalEditTax close={handleEditCancel} Tax={Tax} />
      </Modal>
      <div className="flex items-center gap-2 text-2xl font-semibold leading-7 text-color-primary text-end">
        {intl.formatMessage({ id: "vatSettings.title" })}
      </div>
      <div className="my-4 text-base font-normal leading-7 text-color-gray ">
        {intl.formatMessage({ id: "vatSettings.description" })}
      </div>
      <Form form={form}>
        <div className="bg-[#EEF0FF] px-4 py-6 rounded-lg Taxes">
          <div className="w-full p-4 bg-white rounded-lg">
            <div className="flex flex-col items-center justify-between">
              <span className="w-full mb-4 text-sm text-color-primary">
                {intl.formatMessage({ id: "availableValues" })} :
              </span>
              <div className="flex items-center justify-between w-full">
                <div className="flex flex-wrap items-center justify-between gap-4 my-auto max-lg:flex-col">
                  {isLoading && <Spin></Spin>}
                  {isLoading ||
                    taxes?.data?.map((e: any) => (
                      <div
                        key={e.id}
                        className="flex items-center gap-4 py-3 border-color-primary border-solid border-[1px] rounded-lg bg-[#FBFBFF] p-4"
                      >
                        <span>{e?.name[locale]}</span>
                        <span>{parseFloat(e?.tax_rate).toFixed()}%</span>
                        <span
                          onClick={() => showEditModal(e)}
                          className="flex items-center -mx-1 cursor-pointer"
                        >
                          {editSVG}
                        </span>
                        <span
                          onClick={() => DeleteTax(e.id)}
                          className="flex items-center -mx-1 cursor-pointer"
                        >
                          {deleteSVG}
                        </span>
                      </div>
                    ))}
                </div>
                <Button
                  type="primary"
                  className="flex items-center self-start gap-2 lg:my-auto"
                  onClick={showModal}
                >
                  {addSVG} {intl.formatMessage({ id: "addNew" })}
                </Button>
              </div>
            </div>
            <Divider className="my-4" />
            {/* <div>
              <span className="text-lg font-semibold max-md:text-base">
                {intl.formatMessage({ id: "currentVATValue" })}
              </span>
              {isLoading && <Spin></Spin>}

              {isLoading ||
                locations?.data?.map((e: any) => (
                  <div className="flex items-center justify-between bg-[#EEF0FF] py-2 px-3 rounded-lg my-4">
                    <span className="flex items-center gap-2">
                      {salonSVG} {e.name}
                    </span>
                    <Select
                      optionFilterProp="children"
                      onChange={onChange}
                      className="min-w-[100px]"
                      filterOption={filterOption}
                      defaultValue={"5"}
                      options={options}
                    />
                  </div>
                ))}
            </div>

            <div className="flex flex-col items-center w-full gap-1 max-lg:mt-2">
              <div className="flex items-center justify-between w-full">
                <div className="text-sm max-md:text-xs">
                  {intl.formatMessage({ id: "defaultVATStatus" })}
                </div>
                <Switch />
              </div>
              <p className="text-[#9999A7] w-full text-xs max-md:text-[10px] flex items-center gap-2">
                {noticeSVG} {intl.formatMessage({ id: "vatStatusNotice" })}
              </p>
            </div> */}
          </div>
        </div>
        <div className="flex items-end justify-end w-full gap-4 my-4 mt-8 text-left">
          <Button
            type="primary"
            htmlType="submit"
            className="w-fit min-w-[150px] max-w-[150px]"
          >
            {intl.formatMessage({ id: "saveChanges" })}
          </Button>

          <Button
            type="primary"
            className="btn-primary-not w-fit max-w-[150px] min-w-[150px]"
            onClick={() => navigate(-1)}
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Taxes;
